/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiSpotWeld = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3.138 16.683v-1.554c1.045.41 2.053.616 3.024.616.681 0 1.213-.126 1.596-.378.392-.252.588-.597.588-1.036a.996.996 0 0 0-.364-.798c-.243-.215-.695-.439-1.358-.672l-1.064-.392c-.905-.336-1.554-.728-1.946-1.176-.383-.457-.574-1.013-.574-1.666 0-.896.336-1.6 1.008-2.114.672-.523 1.587-.784 2.744-.784.485 0 .97.051 1.456.154.495.103.924.243 1.288.42v1.554c-.961-.401-1.871-.602-2.73-.602-1.335 0-2.002.43-2.002 1.288 0 .308.121.56.364.756.243.196.686.415 1.33.658l1.078.392c.943.345 1.6.742 1.974 1.19.383.448.574 1.027.574 1.736 0 .933-.331 1.666-.994 2.198s-1.591.798-2.786.798a8.81 8.81 0 0 1-1.19-.084 9.877 9.877 0 0 1-1.134-.196 5.019 5.019 0 0 1-.882-.308zm9.786.406-2.128-7.364h1.722l1.274 4.83 1.4-4.62h1.386l1.4 4.704 1.316-4.914h1.666l-2.114 7.364h-1.372l-1.596-5.194-1.582 5.194h-1.372z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiSpotWeld as PmiSpotWeld };
